import { render, staticRenderFns } from "./SocialList.vue?vue&type=template&id=ffc75562&scoped=true&"
import script from "./SocialList.vue?vue&type=script&lang=ts&"
export * from "./SocialList.vue?vue&type=script&lang=ts&"
import style0 from "./SocialList.vue?vue&type=style&index=0&id=ffc75562&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc75562",
  null
  
)

export default component.exports